module.exports = __webpack_public_path__ + "static/img/A-androidp.1204dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-androidp.png
// module id = w045
// module chunks = 3